import { GET_API_ACCESS_KEY } from '../types';

const initialState = {
  accessKeyList: []
};

export default function AccessKeyReducer(state = initialState, action) {
  switch (action.type) {
    case GET_API_ACCESS_KEY:
      return {
        ...state,
        accessKeyList: action.payload
      };
    default:
      return state;
  }
}
